module.exports = __webpack_public_path__ + "img/vip1.ab369f57.png";